// shared-package/queries/contests.ts
import { useQuery, useMutation, } from "@tanstack/react-query";
export const createContestsQueries = (requests, queryClient) => ({
    useListContests: (params, options = {}) => useQuery({
        queryKey: ["contests", params],
        queryFn: async ({ queryKey }) => {
            const [_key, params] = queryKey;
            return requests.listContests(params);
        },
        ...options,
    }),
    useFindContest: (params, options = {}) => useQuery({
        queryKey: ["contests", params],
        queryFn: async ({ queryKey }) => {
            const [_key, params] = queryKey;
            return requests.findContest(params);
        },
        ...options,
    }),
    useCreateContest: (options = {}) => useMutation({
        ...options,
        mutationFn: requests.createContest,
        onSuccess: (data, variables, context) => {
            queryClient.invalidateQueries({ queryKey: ["contests"] });
            options.onSuccess?.(data, variables, context);
        },
    }),
    useUpdateContest: (options = {}) => useMutation({
        ...options,
        mutationFn: requests.updateContest,
        onSuccess: (data, variables, context) => {
            queryClient.invalidateQueries({ queryKey: ["contests"] });
            options.onSuccess?.(data, variables, context);
        },
    }),
});
//# sourceMappingURL=index.js.map